import React from 'react';
import './Navigation.css';

export interface NavigationProps {
  children: React.ReactNode;
  /** Color variant — defaults to dark */
  variant?: 'dark' | 'light';
  /** Show a "Super Admin" indicator tag */
  showSuperAdminTag?: boolean;
  /** Content rendered in the center section (e.g., search) */
  centerContent?: React.ReactNode;
  /** Content rendered in the right-hand section */
  secondaryItems?: React.ReactNode;
  className?: string;
}

function NavigationLogo({ children }: { children: React.ReactNode }) {
  return <div className="navigation__logo">{children}</div>;
}

export function Navigation({
  children,
  variant = 'dark',
  showSuperAdminTag = false,
  centerContent,
  secondaryItems,
  className = '',
}: NavigationProps) {
  const variantClass = variant === 'light' ? 'navigation--light' : '';

  return (
    <nav
      className={`navigation ${variantClass} ${className}`.trim()}
      role="navigation"
    >
      <ul className="navigation__primary">{children}</ul>

      {centerContent && (
        <div className="navigation__center">{centerContent}</div>
      )}

      <div className="navigation__secondary">
        {showSuperAdminTag && (
          <span className="navigation__admin-tag">Super Admin</span>
        )}
        <ul className="navigation__secondary-list">{secondaryItems}</ul>
      </div>
    </nav>
  );
}

Navigation.Logo = NavigationLogo;
